export const deData = `
  <div class="paragraph">
    <div class="title">ALLGEMEINE GESCHÄFTSBEDINGUNGEN (AGB)</div>
    <div class="text-box">
      <div class="text">
        <br><br>
        Dieser Trade-In-Service („Service“) wird von Danghuan Europe S.L., einer nach
        spanischem Recht gegründeten Gesellschaft mit Sitz in Madrid, Spanien (28045), mit
        der USt-IdNr. B19961911 (im Folgenden „Danghuan“ genannt) betrieben. Kontakt:
        legal@danghuan.eu. Die OPPO-Gesellschaften – Reflection Investment B.V. für
        Spanien und Frankreich sowie Unumplus Limited für das Vereinigte Königreich –
        (nachfolgend gemeinsam „OPPO“) bewerben die Verfügbarkeit dieses Trade-In-
        Dienstes auf ihren offiziellen Webseiten. OPPO selbst betreibt, verwaltet oder verarbeitet
        jedoch keinen Teil des Trade-In-Programms.
        <br><br>
        Diese Bedingungen regeln die Teilnahme von Verbrauchern mit Wohnsitz in der
        Europäischen Union am offiziellen Trade-In-Programm für ausgewählte OPPO-Produkte.
        Der Service erfolgt im Einklang mit dem Unionsrecht, insbesondere der Richtlinie
        2011/83/EU über die Rechte der Verbraucher und der Datenschutz-Grundverordnung
        (Verordnung (EU) 2016/679 – DSGVO).
        <br><br>
        Für Verbraucher mit Wohnsitz im Vereinigten Königreich gilt das Programm gemäß dem
        dort anwendbaren Recht, insbesondere dem Consumer Rights Act 2015 sowie dem
        UK GDPR (Datenschutzgesetz 2018).
        <br><br>
        ARTIKEL 1 – GEOGRAFISCHER GELTUNGSBEREICH UND PRODUKTE
        <br><br>
        1.1. Der Trade-In-Service steht natürlichen Personen ab 18 Jahren offen, die ihren
        rechtmäßigen Wohnsitz in einem Mitgliedstaat der Europäischen Union oder im
        Vereinigten Königreich haben.
        <br><br>
        1.2. Teilnehmer müssen als Verbraucher im Sinne von § 13 BGB (bzw. der Richtlinie
        2011/83/EU) handeln, also zu Zwecken, die überwiegend weder ihrer gewerblichen noch
        ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können.
        <br><br>
        1.3. Pro qualifizierendem Kaufvorgang kann nur ein (1) gebrauchtes Gerät
        eingetauscht werden.
        <br><br>
        1.4. 1.4 Der Service gilt ausschließlich für Kunden, die ein berechtigtes OPPO-Produkt
        („Produkt“) über die offiziellen OPPO-Onlineshops in Deutschland, Frankreich, Spanien
        oder dem Vereinigten Königreich während des jeweiligen Aktionszeitraums erwerben.
        Nur die auf der Website ausgewiesenen OPPO-Modelle sind teilnahmeberechtigt.
        <br><br>
        1.5. Das eingetauschte Gerät („Altgerät“) muss auf der Liste der berechtigten Modelle
        auf der offiziellen Website erscheinen und die in Artikel 5 beschriebenen Funktions- und
        Eigentumskriterien erfüllen.
        <br><br>
        1.6. Der Kunde darf für jedes neu erworbene Produkt nur ein (1) Altgerät einsenden.
        <br><br>
        ARTIKEL 2 – VERTRAGLICHE GRUNDLAGEN
        <br><br>
        2.1. Der Trade-In-Service ist eigenständig und nicht Bestandteil des Kaufvertrags über
        das neue Produkt. Er stellt somit kein verbundenes oder kombiniertes Angebot mit einem
        Gerätehersteller, Händler oder Vertriebspartner dar.
        <br><br>
        2.2. Sämtliche betrieblichen Pflichten im Rahmen des Services – einschließlich
        Kundenkommunikation, Gerätekontrolle, Logistik, Bewertung, Auszahlung und
        Verarbeitung personenbezogener Daten – liegen ausschließlich bei Danghuan Europe
        S.L.
        <br><br>
        2.3. Nichts in diesen Bedingungen schränkt die gesetzlichen Verbraucherrechte nach
        geltendem Recht ein, insbesondere gemäß Richtlinie 2011/83/EU oder dem UK
        Consumer Rights Act 2015.
        <br><br>
        2.4. Danghuan behält sich das Recht vor, jede Trade-In-Anfrage abzulehnen, wenn ein
        Verdacht auf Betrug, Missbrauch oder Verstoß gegen diese Bedingungen besteht –
        einschließlich, aber nicht beschränkt auf, Einsendungen im Namen Dritter oder
        Mehrfacheinsendungen desselben Geräts.
        <br><br>
        ARTIKEL 3 – ABLAUF DER TEILNAHME AM SERVICE
        <br><br>
        3.1. Kunden können während des Kaufvorgangs im offiziellen OPPO-Onlineshop am
        Trade-In-Service teilnehmen.
        <br><br>
        3.2. Zur Durchführung muss der Kunde einen Selbstbewertungsfragebogen ausfüllen
        und die erforderlichen Geräteinformationen angeben, einschließlich, aber nicht
        beschränkt auf IMEI, Modell und Gerätezustand.
        <br><br>
        • Bitte stellen Sie sicher, dass das Modell Ihres alten Geräts korrekt ausgewählt ist.
        Falls eine Änderung erforderlich ist, kontaktieren Sie uns bitte so schnell wie möglich
        unter oppo@danghuan.eu, damit wir die Geräteinformationen aktualisieren können.
        <br><br>
        3.3. Der Kunde muss korrekte und gültige Bankverbindungsdaten für die Auszahlung
        angeben:
        <br><br>
        • Für Kunden im EU-/EWR-Raum: ein SEPA-fähiges IBAN-Konto bei einem in der
        SEPA-Zone ansässigen Kreditinstitut.
        <br><br>
        • Für Kunden im Vereinigten Königreich: ein auf ihren Namen lautendes GBP-Konto
        (mit Sort Code und Kontonummer), das Zahlungen über Faster Payments oder
        BACS empfangen kann.
        <br><br>
        3.4. Der Kunde erhält innerhalb von 24 Stunden, nachdem das neue Gerät im
        Logistiksystem als „zugestellt“ markiert wurde, eine E-Mail mit Trade-In-Anweisungen.
        <br><br>
        3.5. Der Kunde muss alle erforderlichen Dokumente (z. B. die unterschriebene Erklärung
        zur Geräteehrlichkeit und Eigentümerschaft) hochladen und das Altgerät innerhalb von
        10 Kalendertagen nach Lieferung des neuen Geräts versenden.
        <br><br>
        3.6. Wenn diese Schritte nicht innerhalb der angegebenen Frist abgeschlossen werden,
        wird die Trade-In-Anfrage automatisch storniert.
        <br><br>
        3.7. Unvollständige, widersprüchliche oder falsche Angaben – etwa eine nicht
        übereinstimmende IMEI oder fehlende Unterlagen – können zur Ablehnung der Anfrage
        ohnee Anspruch auf Entschädigung führen.
        <br><br>
        3.8. Das Altgerät muss sicher verpackt werden, gemäß den bereitgestellten
        Versandhinweisen. Der Versand ist durch Danghuan vorfrankiert. Bei Verlust oder
        Beschädigung während des Transports muss der Kunde innerhalb von 15
        Kalendertagen nach dem letzten Sendungsstatus eine E-Mail an OPPO@danghuan.eu
        senden.
        <br><br>
        Danghuan stellt daraufhin den Zugang zum offiziellen UPS-Beschwerdeverfahren bereit
        und unterstützt den Kunden bei der Schadensmeldung.
        <br><br>
        Bitte beachten: Transportreklamationen müssen innerhalb von 60 Tagen ab dem
        Erstellungsdatum des Versandlabels eingereicht werden. Etwaige genehmigte
        Entschädigungen werden direkt an das vom Kunden angegebene IBAN-Konto
        überwiesen. Danghuan übernimmt in diesen Fällen keine weitere Haftung oder
        Ersatzpflicht.
        <br><br>
        3.9. Geräte, die ohne die erforderliche Ehrlichkeits- bzw. Eigentumserklärung oder ohne
        unterzeichnete Verkaufsbestätigung eingehen, werden nicht bearbeitet. Der Kunde wird
        per E-Mail informiert und kann innerhalb von 10 Kalendertagen nach Benachrichtigung
        die Rücksendung des Geräts beantragen. Für die Rücksendung gelten die
        Kostenregelungen gemäß Artikel 6.3. Erfolgt keine Rückmeldung innerhalb dieser Frist,
        behält sich Danghuan das Recht vor, das Gerät ordnungsgemäß zu recyceln oder zu
        entsorgen, ohne weitere Verpflichtungen.
        <br><br>
        3.10. Teilnahmeberechtigte Geräte für den Trade-In-Service umfassen Smartphones,
        Smartwatches, kabellose Ohrhörer und Tablets, die zum Zeitpunkt der Teilnahme auf
        der offiziellen OPPO-Website gelistet sind.
        <br><br>
        ARTIKEL 4 – ANNAHMEBEDINGUNGEN DER GERÄTE
        <br><br>
        4.1. Nur die auf der offiziellen OPPO-Webseite veröffentlichten und als
        teilnahmeberechtigt aufgeführten Modelle (einschließlich Smartphones, Smartwatches,
        kabelloser Ohrhörer und Tablets) werden im Rahmen des Trade-In-Programms
        akzeptiert.
        <br><br>
        4.2. Alle eingesendeten Geräte müssen die von Danghuan Europe S.L. festgelegten
        Bewertungs- und optischen Standards erfüllen. Die Geräte werden nach der zertifizierten
        Prüfung in die Zustandskategorien A, B oder C eingestuft, wie in Artikel 6 näher
        beschrieben.
        <br><br>
        4.3.Jedes Gerät muss mindestens die folgenden Funktions- und Zustandskriterien
        erfüllen:
        <br><br>
        – Smartphones und Tablets: Das Gerät muss sich einschalten lassen, über einen
        funktionsfähigen Touchscreen und Akku verfügen, darf keine gravierenden physischen
        Schäden (z. B. gesprungenes Display, Korrosion) aufweisen und muss auf
        Werkseinstellungen zurückgesetzt sein. Alle Sperren oder Konten (z. B. PIN, Apple
        iCloud, Google FRP, Samsung oder Xiaomi) müssen deaktiviert sein.
        <br><br>
        – Smartwatches: Das Gerät muss sich einschalten lassen, frei von aktiven Kontosperren
        (z. B. iCloud, Google, Samsung) sein und technisch einwandfrei funktionieren. Es dürfen
        keine schweren äußeren Schäden bestehen.
        <br><br>
        – Kabellose Ohrhörer: Beide Ohrhörer und das Ladeetui müssen vorhanden sein, sich
        laden und koppeln lassen und dürfen keine Anzeichen von Wasserschäden oder tiefen
        Rissen zeigen.
        <br><br>
        4.4. Das Gerät muss ausschließliches Eigentum des Kunden sein und darf nicht
        Gegenstand eines Miet-, Leasing- oder Finanzierungsvertrags sein. Geräte, die als
        verloren, gestohlen, gefälscht oder manipuliert (z. B. geänderte Seriennummer oder
        IMEI) gemeldet sind, werden ohne Entschädigung abgelehnt.
        <br><br>
        4.5. Geräte, die die Mindestvoraussetzungen nicht erfüllen, können auf Wunsch des
        Kunden innerhalb von 7 Tagen nach Benachrichtigung zurückgesendet werden. Die
        Benachrichtigung erfolgt per E-Mail. Erfolgt keine Rückmeldung innerhalb dieser Frist,
        kann Danghuan das Gerät ordnungsgemäß recyceln.
        <br><br>
        Wenn der Kunde die Rücksendung eines nicht akzeptierten Geräts verlangt, gelten die
        Rücksendevorgaben und Kostenregelungen gemäß Artikel 6.3.
        <br><br>
        ARTIKEL 5 – LOGISTIKFRISTEN UND VERPFLICHTUNGEN
        <br><br>
        5.1. Der Kunde muss das Altgerät innerhalb von 10 Kalendertagen nach Erhalt des
        neuen OPPO-Geräts versenden.
        <br><br>
        5.2. Erinnerungs-E-Mails werden von Danghuan an den Tagen D+3, D+6 und D+9 nach
        der Lieferung des neuen Geräts versendet.
        <br><br>
        5.3. Alle Geräte müssen mit dem vorfrankierten Versandlabel verschickt werden, das
        von Danghuan Europe S.L. zur Verfügung gestellt wird.
        <br><br>
        5.4. Wird das Versandlabel nicht bis spätestens Tag 15 (D+14) vom Logistikdienstleister
        eingescannt, wird der Trade-In-Auftrag automatisch storniert.
        <br><br>
        5.5. Der Kunde ist verpflichtet, das Gerät sicher zu verpacken, um Transportschäden zu
        vermeiden. Danghuan stellt Verpackungsrichtlinien, jedoch keine physischen Materialien
        zur Verfügung.
        <br><br>
        5.6. Geräte, deren IMEI nicht mit der ursprünglich angegebenen übereinstimmt oder
        deren Zustand erheblich vom angegebenen abweicht, können zu einer angepassten
        Bewertung oder Stornierung führen.
        <br><br>
        ARTIKEL 6 – PRÜFUNG, BEWERTUNG UND ANNAHME
        <br><br>
        6.1. Geräteprüfung: Die eingesendeten Geräte werden innerhalb von drei (3) Werktagen
        nach Eingang im vorgesehenen Lager geprüft. Die Prüfung umfasst sowohl eine
        funktionale Diagnose mittels zertifizierter Prüfsoftware als auch eine visuelle
        Begutachtung zur Ermittlung des äußeren Zustands (Einstufung in Grad A, B oder C).
        <br><br>
        6.2. Überarbeitete Bewertung: Weicht der tatsächliche Zustand oder die Spezifikation
        des Geräts von der ursprünglichen Angaben des Kunden ab, sendet Danghuan Europe
        S.L. eine überarbeitete Bewertung (neues Angebot) per E-Mail, in der der neue
        Gerätezustand und die Begründung für die Anpassung klar erläutert werden.
        <br><br>
        6.3. Der Kunde hat 7 Kalendertage ab dem Datum der Benachrichtigung, um das neue
        Angebot anzunehmen oder abzulehnen. Während dieser Frist kann er auch eine
        Rücksendung seines Geräts beantragen.
        <br><br>
        • Für Kunden mit Wohnsitz in Spanien übernimmt Danghuan die
        Rücksendekosten vollständig.
        <br><br>
        • Für Kunden in anderen Ländern trägt der Kunde die Rücksendekosten selbst, bis
        zu einem Höchstbetrag von 22 EUR (bzw. 19 GBP / 165 DKK / 245 SEK, inkl.
        MwSt.), unter Verwendung des von Danghuan bereitgestellten vorfrankierten
        Rücksendeetiketts.
        <br><br>
        Die Zahlungsinformationen werden dem Kunden auf Anfrage oder per E-Mail mit dem
        Zahlungslink zur Verfügung gestellt.
        <br><br>
        Zahlungsmöglichkeiten:
        <br><br>
        • Für EU-/EWR-Kunden: SEPA-Überweisung auf das IBAN-Konto von Danghuan.
        <br><br>
        • Für UK-Kunden: GBP-Überweisung auf das britische Konto von Danghuan (Sort
        Code + Account Number), per Faster Payments oder BACS.
        <br><br>
        Wird die Rücksendegebühr nicht innerhalb von 10 Kalendertagen nach Versand der
        Zahlungsaufforderung beglichen, behält sich Danghuan das Recht vor, das neue
        Angebot als akzeptiert zu behandeln und das Gerät entsprechend weiterzuverarbeiten.
        <br><br>
        Erstattungen von gezahlten Rücksendegebühren erfolgen per Banküberweisung
        innerhalb von 5 Werktagen, nachdem die Zahlung von Danghuan geprüft wurde.
        Die Rückerstattung erfolgt auf dasselbe Konto, das der Kunde bei der Registrierung
        angegeben hat.
        <br><br>
        6.4. Wenn der Kunde innerhalb von 7 Kalendertagen nicht auf das überarbeitete
        Angebot reagiert, wird der Kundenservice versuchen, ihn direkt zu kontaktieren, um
        eine Bestätigung einzuholen. Erfolgt innerhalb von 30 Kalendertagen ab
        Benachrichtigungsdatum keine Reaktion, gilt das überarbeitete Angebot als abgelehnt.
        <br><br>
        Für Kunden außerhalb Spaniens gilt:
        In diesem Fall fällt eine Rücksendekostenpauschale gemäß obiger Regelung an, die
        innerhalb von 5 Tagen nach Erhalt der Zahlungsaufforderung zu begleichen ist. Nach
        Zahlungseingang organisiert Danghuan innerhalb von 5 Werktagen den Rückversand
        <br><br>
        an die ursprüngliche Adresse des Kunden. Der Kunde wird per E-Mail über den
        Versand informiert und erhält die Sendungsverfolgung.
        <br><br>
        Der Kunde ist dafür verantwortlich, den Status der Rücksendung aktiv zu überwachen und, sofern erforderlich, die rechtzeitige Abholung oder Entgegennahme des Pakets zu veranlassen. Danghuan Europe S.L. wird den Kunden im Voraus per E-Mail über die Sendungsverfolgungsnummer der Rücksendung sowie über relevante logistische Informationen informieren. Kommt der Kunde seiner Verpflichtung zur Abholung oder Entgegennahme des Pakets innerhalb der vom Logistikdienstleister vorgegebenen Frist nicht nach, sodass das Paket zurückgesendet wird oder ein erneuter Versand erforderlich ist, gehen sämtliche zusätzlich entstehenden Versand- oder Bearbeitungskosten ausschließlich zu Lasten des Kunden. Danghuan Europe S.L. haftet nicht für derartige Kosten oder daraus resultierende Folgen.
        6.5. Geräte, die aufgrund irreparabler Schäden, Manipulation oder anderer
        Ausschlussgründe (z. B. iCloud-Sperre, Diebstahlmeldung, nicht übereinstimmende
        IMEI) als nicht teilnahmefähig gelten, erhalten keine Bewertung. Der Kunde hat ab
        Benachrichtigung 7 Kalendertage, um eine Rücksendung zu beantragen; andernfalls
        wird das Gerät ordnungsgemäß recycelt.
        <br><br>
        6.6. Die Auszahlung für akzeptierte Geräte erfolgt innerhalb von drei (3) Werktagen nach
        Annahme des Angebots durch den Kunden per SEPA-Banküberweisung.
        <br><br>
        6.7. Bewertungs- und Einstufungskriterien
        Die Geräte werden gemäß den folgenden Kategorien bewertet; jede Produktkategorie
        (Smartphone, Tablet, Smartwatch, Ohrhörer) hat spezifische Anforderungen:
        <br><br>
        I. Smartphones and Tablets
        <br><br>
        Grad A – Hervorragender Zustand
        <br><br>
        • Normale Gebrauchsspuren, insgesamt sehr guter Zustand.
        <br><br>
        • Keine Risse, Dellen oder Lackschäden.
        <br><br>
        • Alle Funktionen (Display, Touch, Kamera, Tasten, Lautsprecher, Akku,
        Konnektivität usw.) funktionieren einwandfrei.
        <br><br>
        • Bei Apple-Geräten: Batteriezustand ≥ 90 %.
        <br><br>
        Grad B – Leichte Gebrauchsspuren
        <br><br>
        • Übliche Gebrauchsspuren, aber insgesamt guter Zustand.
        <br><br>
        • 2 – 3 kleine Kratzer oder Schrammen zulässig, keine groben Beschädigungen.
        <br><br>
        • Alle Hauptfunktionen (Display, Touch, Sensoren, Bluetooth usw.) funktionieren
        ordnungsgemäß.
        <br><br>
        • Bei Apple-Geräten: Batteriezustand ≥ 80 %.
        <br><br>
        Grad C – Deutliche Gebrauchsspuren
        <br><br>
        • Mehrere Kratzer, Lackabrieb oder kleine Dellen sichtbar.
        <br><br>
        • Ein feiner Sprung im Display zulässig, sofern die Funktion nicht beeinträchtigt ist.
        <br><br>
        • Hauptfunktionen (Display, Touch, Kamera, Konnektivität usw.) weiterhin
        funktionsfähig.
        <br><br>
        Grad D – Nicht funktionsfähig / Abgelehnt
        <br><br>
        • Gerät stark beschädigt oder lässt sich nicht einschalten.
        <br><br>
        • Tiefe Risse, verbogener Rahmen, defektes Display/Gehäuse, fehlende Teile,
        Mainboard-Schaden, Korrosion, keine Anzeige oder Touchreaktion.
        <br><br>
        • Gesperrte Geräte (z. B. Google / iCloud / PIN) sind ausgeschlossen.
        <br><br>
        • Die Gerätesbatterie ist aufgebläht oder weist andere Probleme auf, die nicht den
        Sicherheitsstandards entsprechen, z. B. übermäßige Überhitzung oder ein durch
        die Batterie aufgeweitetes Gehäuse.
        <br><br>
        II. Smartwatches und Fitnessbänder
        <br><br>
        Grad A – Hervorragender Zustand
        <br><br>
        • Normale Gebrauchsspuren, kein Riss, kein Farbverlust oder Verfärbung.
        <br><br>
        • No cracks, paint loss, or discoloration.
        <br><br>
        • Alle Funktionen (Touch, Krone, Sensoren, Bluetooth, WLAN) einwandfrei.
        <br><br>
        • Bei Apple-Geräten: Batteriezustand ≥ 90 %.
        <br><br>
        Grad B – Leichte Gebrauchsspuren
        <br><br>
        • Kleine Kratzer oder Schrammen möglich, keine strukturellen Schäden.
        <br><br>
        • Alle Hauptfunktionen funktionieren ordnungsgemäß.
        <br><br>
        • All key functions (display, touch, sensors, Bluetooth) operate normally.
        <br><br>
        • Bei Apple-Geräten: Batteriezustand ≥ 80 %.
        <br><br>
        Grad C – Deutliche Gebrauchsspuren
        <br><br>
        • Mehrere Kratzer, Lackabrieb oder kleine Dellen.
        <br><br>
        • Einige Sensoren oder Tasten reagieren verzögert, Hauptfunktionen jedoch intakt.
        <br><br>
        • Batterielaufzeit leicht reduziert (&lt; 80 %).
        <br><br>
        Grad D – Nicht funktionsfähig / Abgelehnt
        <br><br>
        • Stark beschädigt oder lässt sich nicht einschalten.
        <br><br>
        • Gesprungenes Display, defekte Krone/Tasten, Mainboard-Schaden,
        Kontosperre (iCloud / Google / PIN) oder Korrosion.
        <br><br>
        • Nicht für den Trade-In zugelassen.
        <br><br>
        III. Kabellose Ohrhörer
        <br><br>
        Grad A – Hervorragender Zustand
        <br><br>
        • Sehr sauber, keine Kratzer oder Flecken.
        <br><br>
        • Alle Funktionen (Klang, Touch, Mikrofon, Bluetooth, Laden) einwandfrei.
        <br><br>
        • Ladeetui unbeschädigt und funktionsfähig.
        <br><br>
        Grad B – Leichte Gebrauchsspuren
        <br><br>
        • Geringe Oberflächenmarken oder Schrammen, aber technisch einwandfrei.
        <br><br>
        • Tonqualität normal, Bluetooth stabil, Ladeetui mit leichten Spuren.
        <br><br>
        • Touch und Mikrofon funktionieren korrekt.
        <br><br>
        Grad C – Deutliche Gebrauchsspuren
        <br><br>
        • Mehrere Kratzer, Farbverblassung oder kleine Dellen sichtbar.
        <br><br>
        • Ton oder Mikrofon leicht beeinträchtigt, aber funktionsfähig.
        <br><br>
        • Bluetooth instabil, Ladeetui mit sichtbaren Kratzern oder kleinen Schäden.
        <br><br>
        Grad D – Nicht funktionsfähig / Abgelehnt
        <br><br>
        • Unvollständig, nicht einschaltbar oder wesentliche Funktionen defekt.
        <br><br>
        • Fehlender Ohrhörer / Etui, Akkudefekt, gebrochener Ladeanschluss, keine
        Bluetooth-Verbindung oder Wasserschaden.
        <br><br>
        • Nicht für den Trade-In zugelassen.
        <br><br>
        6.8. Entspricht das eingesendete Gerät nicht dem vom Kunden ursprünglich
        angegebenen Modell oder der Seriennummer, nimmt Danghuan mit dem Kunden
        Kontakt auf und unterbreitet ein neues Angebot. Ist das eingesendete Gerät für das
        Trade-In-Programm geeignet, wird eine neue Bewertung basierend auf dem
        tatsächlichen Zustand erstellt. Der Kunde muss das neue Angebot prüfen, annehmen
        und eine neue Eigentums- und Ehrlichkeitserklärung für das betreffende Gerät
        unterzeichnen, bevor der Trade-In-Prozess fortgesetzt werden kann. Wird das Angebot
        nicht innerhalb von 7 Kalendertagen angenommen, kann der Kunde die Rücksendung
        gemäß Artikel 6.3 beantragen.
        <br><br>
        6.9. Der Kunde ist verpflichtet, eine unterzeichnete Erklärung über Eigentum und
        Integrität des eingesendeten Geräts vorzulegen. Wird dieses Dokument nicht
        ordnungsgemäß ausgefüllt, unterschrieben oder eingereicht, kann der Trade-In-Antrag
        abgelehnt werden. In solchen Fällen kann das Gerät – auf Wunsch des Kunden und
        unter den Bedingungen von Artikel 6.3 – zurückgesendet oder nach Ablauf der Frist
        ordnungsgemäß recycelt werden.
        <br><br>
        6.10. Das dem Kunden ursprünglich unterbreitete Inzahlungnahmeangebot ist unverbindlich und vorbehaltlich einer Überprüfung. Obwohl der angebotene Wert für einen begrenzten Zeitraum nach Lieferung des neuen Geräts bestehen bleiben kann, behält sich Danghuan Europe S.L. das Recht vor, das Angebot auf Grundlage verschiedener Faktoren, einschließlich, aber nicht beschränkt auf den Gerätezustand, Marktschwankungen und Bearbeitungszeiten, zu überprüfen und anzupassen.
        Aufgrund der Beschaffenheit des Marktes für elektronische Geräte kann der Wert von Geräten im Laufe der Zeit sinken. Als allgemeine Orientierung können die Preise wöchentlich schrittweise sinken, in der Regel um etwa 6 %, wobei die tatsächlichen Anpassungen je nach Marktbedingungen und Produktkategorien variieren können.
        In Fällen, in denen der Inzahlungnahmeprozess nicht innerhalb eines angemessenen Zeitraums abgeschlossen wird oder sich die Marktbedingungen erheblich ändern, kann der ursprünglich angebotene Wert nicht mehr gelten.
        <br><br>
        ARTIKEL 7 – ZAHLUNGSBEDINGUNGEN
        <br><br>
        7.1. Auszahlungen erfolgen ausschließlich per Banküberweisung auf ein Konto, das auf
        den Namen des Kunden lautet und im Rahmen der Trade-In-Registrierung angegeben
        wurde.
        <br><br>
        7.2. Für Kunden mit Wohnsitz in der Europäischen Union oder im Europäischen
        Wirtschaftsraum (EWR) erfolgt die Zahlung über eine SEPA-Überweisung auf ein
        gültiges IBAN-Konto innerhalb der SEPA-Zone.
        <br><br>
        7.3. Für Kunden mit Wohnsitz im Vereinigten Königreich erfolgt die Zahlung in GBP per
        Faster Payments oder BACS-Überweisung auf ein britisches Bankkonto, sofern dieses
        auf den Namen des Kunden lautet und alle erforderlichen Angaben korrekt sind.
        <br><br>
        7.4. Prepaid-Karten, virtuelle Konten oder Bankdaten, die nicht mit dem registrierten
        Kundennamen übereinstimmen, führen zu einem Zahlungsfehler und können zur
        Stornierung der Trade-In-Transaktion führen.
        <br><br>
        7.5. Danghuan Europe S.L. haftet nicht für Verzögerungen oder Fehler, die durch
        unvollständige, fehlerhafte oder abgelaufene Bankdaten entstehen.
        <br><br>
        7.6. Gibt der Kunde falsche oder ungültige Kontodaten an und wird die Zahlung dennoch
        erfolgreich auf das angegebene Konto ausgeführt, übernimmt Danghuan keine Haftung
        für daraus entstehende Verluste. Der Kunde trägt die alleinige Verantwortung für die
        Richtigkeit seiner Bankverbindung. Eine zweite Auszahlung wird in einem solchen Fall
        nicht vorgenommen.
        <br><br>
        7.7. Nach Abschluss des Trade-In-Prozesses gilt: Wenn der rückzahlbare Betrag laut
        Bestellung geringer ist als der gewährte Trade-In-Bonus, wird nur der verbleibende
        Differenzbetrag ausgezahlt.
        <br><br>
        7.8. Ein Trade-In-Bonus (sofern gewährt) wird ungültig, wenn die Bestellung des neuen
        Produkts storniert oder rückerstattet wird.
        <br><br>
        7.9. Alle mit der Auszahlung verbundenen Bankgebühren werden von Danghuan Europe
        S.L. getragen.
        <br><br>
        7.10. Der insgesamt an den Kunden auszuzahlende Betrag kann aus zwei separaten
        Überweisungen bestehen:
        (a) dem Trade-In-Wert des Geräts, ausgezahlt durch Danghuan; und
        (b) einem ggf. gewährten Aktionsbonus, ausgezahlt separat durch OPPO auf dasselbe
        Konto.
        Die beiden Zahlungen können zeitlich unterschiedlich eingehen, abhängig von den
        jeweiligen Bearbeitungsfristen der Parteien.
        <br><br>
        ARTIKEL 8 – HAFTUNG UND VERLUSTREGELUNG
        <br><br>
        8.1. Der Kunde ist verpflichtet, ausschließlich das von Danghuan Europe S.L.
        bereitgestellte vorfrankierte Versandlabel sowie den zugewiesenen Logistikdienstleister
        zu verwenden. Die Nutzung alternativer Versandmethoden führt zum Erlöschen des
        Haftungsschutzes.
        <br><br>
        8.2. Ein Gerät gilt als verloren, wenn es innerhalb von 15 Kalendertagen nach der
        Übergabe an den Logistikdienstleister nicht nachverfolgt, bestätigt oder von Danghuan
        Europe S.L. empfangen wurde.
        <br><br>
        • Für Sendungen über UPS muss der Anspruch innerhalb von 60 Tagen ab
        Erstellungsdatum des Versandlabels eingereicht werden.
        <br><br>
        • Für Sendungen innerhalb Spaniens über Correos sollte die Reklamation so bald
        wie möglich, idealerweise innerhalb von 15 Tagen, spätestens jedoch innerhalb
        eines Jahres nach Versanddatum erfolgen.
        <br><br>
        Danghuan unterstützt den Kunden bei der Einreichung der Reklamation beim jeweiligen
        Transportdienstleister. Die Bearbeitungsdauer solcher Verfahren beträgt in der Regel 30
        bis 60 Tage.
        <br><br>
        8.3. Diese Haftungsregelung gilt gleichermaßen für Sendungen vom Kunden an
        Danghuan Europe S.L. sowie für etwaige Rücksendungen von Danghuan an den
        Kunden.
        <br><br>
        8.4. Im Falle eines bestätigten Verlusts innerhalb des von Danghuan verwalteten
        Logistiksystems hilft Danghuan Europe S.L. dem Kunden, einen formellen Schadensfall
        beim Kurierdienst einzereichen.
        <br><br>
        8.5. Die Haftung und Entschädigung sind ausschließlich auf Fälle beschränkt, in denen
        der Kunde das autorisierte Versandlabel von Danghuan Europe S.L. verwendet hat und
        das Versandereignis nachweislich verifizierbar ist.
        <br><br>
        8.6. Im Falle eines anerkannten Verlusts darf die Entschädigung den letzten bestätigten
        Trade-In-Bewertungsbetrag des Geräts nicht überschreiten, wie er vor der
        Verlustbestätigung festgelegt wurde.
        <br><br>
        ARTIKEL 9 – DATENSCHUTZ UND DSGVO-KONFORMITÄT
        <br><br>
        9.1. Sämtliche vom Kunden im Rahmen der Teilnahme am Trade-In-Programm
        bereitgestellten personenbezogenen Daten werden in voller Übereinstimmung mit den
        geltenden Datenschutzgesetzen verarbeitet – insbesondere gemäß der Datenschutz-
        Grundverordnung (Verordnung (EU) 2016/679 – DSGVO) für Kunden in der EU sowie
        dem UK GDPR und dem Data Protection Act 2018 für Kunden im Vereinigten Königreich.
        Danghuan Europe S.L. fungiert als Verantwortlicher (Data Controller) und setzt
        geeignete technische und organisatorische Maßnahmen ein, um die Vertraulichkeit,
        Integrität und Sicherheit aller im Zusammenhang mit dem Trade-In-Programm
        verarbeiteten Daten zu gewährleisten.
        <br><br>
        9.2. Zu den erhobenen personenbezogenen Daten gehören unter anderem: Name,
        Nachname, E-Mail-Adresse, Postanschrift, Telefonnummer, Bankverbindung,
        Identifikationsdokumente, IMEI des eingesendeten Geräts sowie die im
        Bewertungsformular gemachten Angaben.
        <br><br>
        9.3. Die Verarbeitung dieser Daten erfolgt ausschließlich zu den folgenden Zwecken:
        Identitätsprüfung des Kunden, Bearbeitung und Bewertung des Trade-In-Antrags,
        Organisation von Abholung, Versand und Rücksendung des Geräts, Kundenservice und
        Kommunikation, Buchhaltung, Zahlungsabwicklung und Betrugsprävention.
        <br><br>
        Keine der bereitgestellten personenbezogenen Daten wird zu Marketingzwecken
        verwendet oder an Dritte weitergegeben, sofern keine ausdrückliche Einwilligung des
        Kunden vorliegt, es sei denn, dies ist gesetzlich vorgeschrieben.
        <br><br>
        9.4. Die Daten werden nur so lange gespeichert, wie es zur Durchführung des Trade-In-
        Vorgangs und zur Erfüllung gesetzlicher Pflichten erforderlich ist. Sofern keine
        gesetzlichen Aufbewahrungspflichten bestehen, werden sämtliche Kundendaten
        innerhalb von 30 Kalendertagen nach Abschluss des Trade-In-Prozesses und der
        endgültigen Auszahlung gelöscht. In bestimmten Fällen (z. B. Prüfungen,
        Zahlungsabgleich, Betrugsermittlungen oder Compliance-Kontrollen durch
        Markenpartner) kann die Aufbewahrungsfrist bis zu 90 Kalendertage betragen – stets im
        Einklang mit der DSGVO.
        <br><br>
        9.5. Der Kunde ist allein verantwortlich für die sichere Löschung aller persönlichen Daten
        auf dem eingesendeten Gerät vor dem Versand. Dies umfasst Kontakte, Nachrichten,
        Fotos, Apps, E-Mails, Browserverläufe, Konten und alle vertraulichen Inhalte.
        <br><br>
        9.6. Der Kunde muss zudem sämtliche SIM- und microSD-Karten entfernen sowie alle
        Sicherheitsfunktionen wie Bildschirmsperren, Passwörter oder Cloud-Accounts (z. B.
        Apple iCloud, Google-Konto, Samsung „Find My Mobile“) deaktivieren. Wird dies
        unterlassen, kann das Gerät als nicht teilnahmefähig gelten.
        <br><br>
        9.7. Weitere Informationen zur Datenverarbeitung und zu den Rechten der betroffenen
        Personen (Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch) finden sich
        in der vollständigen Datenschutzerklärung auf der offiziellen Website von Danghuan
        Europe S.L..
        <br><br>
        ARTIKEL 10 – BETRUGS- UND NICHTKONFORMITÄTSPOLITIK
        <br><br>
        10.1. Einsendungen, die falsche Angaben, gesperrte, geleaste, manipulierte oder nicht
        im Eigentum des Kunden befindliche Geräte betreffen, werden ohne Vergütung
        disqualifiziert.
        <br><br>
        10.2. Danghuan Europe S.L. behält sich das Recht vor, solche Teilnehmer von aktuellen
        und zukünftigen Trade-In-Programmen auszuschließen.
        <br><br>
        10.3. In Fällen von Betrug, Identitätsdiebstahl oder dem Versuch, die
        Teilnahmevoraussetzungen zum kommerziellen Vorteil zu umgehen, können rechtliche
        Schritte eingeleitet werden.
        <br><br>
        ARTIKEL 11 – HÖHERE GEWALT
        <br><br>
        11.1 Im Falle von Ereignissen, die außerhalb des zumutbaren Einflussbereichs von
        Danghuan Europe S.L. liegen – einschließlich, aber nicht beschränkt auf
        Naturkatastrophen, behördliche Anordnungen, Pandemien, Arbeitskämpfe oder
        erhebliche Transportstörungen – kann der Trade-In-Service vorübergehend ausgesetzt
        werden, ohne dass hieraus eine Haftung entsteht.
        <br><br>
        11.2. Verzögerungen oder Nichterfüllungen, die unmittelbar auf ein solches Ereignis
        höherer Gewalt zurückzuführen sind, gelten nicht als Vertragsverletzung.
        <br><br>
        ARTIKEL 12 – ANWENDBARES RECHT UND GERICHTSSTAND
        <br><br>
        12.1. Diese Bedingungen unterliegen dem Recht des Königreichs Spanien und werden
        nach diesem ausgelegt. Davon unberührt bleiben alle zwingenden
        Verbraucherschutzrechte, die dem Kunden gemäß den Gesetzen seines
        Wohnsitzlandes innerhalb der Europäischen Union zustehen.
        <br><br>
        12.2. Alle Streitigkeiten, die sich aus oder im Zusammenhang mit diesen Bedingungen
        ergeben, unterliegen der ausschließlichen Zuständigkeit der Gerichte in Madrid, Spanien,
        unbeschadet des Rechts des Verbrauchers, seine Verbraucherschutzrechte im eigenen
        Wohnsitzstaat geltend zu machen.
      </div>
    </div>
  </div>
`;